import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from '../../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../../shared/actions';
import {MarriageService} from '../../services/marriage.service';

@Component({
  selector: 'vb-asset-marriage-view',
  templateUrl: './asset-marriage-view.component.html',
  styleUrls: ['./asset-marriage-view.component.css'],
  providers: [MarriageService]
})
export class AssetMarriageViewComponent extends AbstractVisbosComponent implements OnInit {

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.actions = [];

  }

  ngOnInit() {
    super.ngOnInit();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/views/asset-marriage-view/asset-marriage-view.component.ts